import { IonButton, IonContent, IonPage } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../lib/auth/AuthProvider.js';

export function EmailVerifiedPage(): JSX.Element {
  const history = useHistory();
  const { session, profile } = useAuth();

  function handleStart(): void {
    if (session) {
      const hasTenant = profile?.tenants && profile.tenants.length > 0;
      history.replace(hasTenant ? '/today' : '/auth/bootstrap');
    } else {
      history.replace('/auth/signin');
    }
  }

  return (
    <IonPage>
      <IonContent className="te-page">
        <div className="te-auth-shell" style={{
          minHeight: '100%',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '32px 24px',
        }}>
          <div style={{ textAlign: 'center', marginBottom: 32 }}>
            <div style={{
              width: 88, height: 88, borderRadius: 28,
              background: 'linear-gradient(135deg, #16a34a, #22c55e)',
              color: '#fff', fontSize: 44, fontWeight: 700,
              display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 12px 28px rgba(22,163,74,.25)',
              marginBottom: 20,
            }}>
              ✓
            </div>
            <h1 style={{ margin: '0 0 8px', fontSize: 26, fontWeight: 700, color: '#0f172a', letterSpacing: '-0.01em' }}>
              Account verificato
            </h1>
            <p style={{ margin: 0, fontSize: 14, color: '#64748b', lineHeight: 1.5 }}>
              La tua email è stata confermata.<br />
              Sei pronto per configurare la tua attività.
            </p>
          </div>

          <IonButton
            expand="block"
            onClick={handleStart}
            style={{ '--border-radius': '12px', height: 52, fontSize: 16, fontWeight: 600 } as React.CSSProperties}
          >
            Inizia subito
          </IonButton>
        </div>
      </IonContent>
    </IonPage>
  );
}
